import type { TCountry } from '../types/outerLayout/common';

import { LOCAL_STORAGE_KEYS } from '../constants/local-storage-keys';
import { getFromLocalStorage } from './manageLocalStorage';

export const isAllowedCountry = (country: TCountry[] | TCountry) => {
  const currentCountry = getFromLocalStorage(LOCAL_STORAGE_KEYS.COUNTRY);

  if (!Array.isArray(country)) {
    return country === currentCountry;
  }

  return country.includes(currentCountry);
};
